import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { RootState } from '@/components/WellLoggingOperations/types';

/**
 * init Rigis Residue only if column visible
 */
export const useRigisResidue = (wellId: string, wellKey: string) => {
    const tabletSettings = useSelector((state: RootState) => state.tabletSettings[wellKey]);

    const { initByWell, resetResearchVisibilityById } = useDispatch<any>().rigisResidue;

    useEffect(() => {
        if (tabletSettings?.columnsVisibility.cementBondLogging) {
            initByWell(wellId);
        }

        return () => {
            resetResearchVisibilityById(wellId);
        };
    }, [wellId, initByWell, resetResearchVisibilityById, tabletSettings?.columnsVisibility.cementBondLogging]);
};
